export enum ChartOfAccount {

  SKR03 = 'SKR03',
  SKR04 = 'SKR04',
}
